export class FileDefinitionDTO{
    public id? : number;
    public name! : string;
    public type! : string; //csv or fl
    public hasHeader! : boolean; //indicates if the file received will have a header row.
    public fieldDelimiter?:string;
    public unevenRows?:boolean;
    public fieldDefinition! : string; //json string representing datafield information like position, name, datatype, etc. in json array: [{<field1>},{<field2>},{<field3>}, ...]
    public version? : number; //incremental version number set by server
    public published : boolean = false; //if true, then can be used for moovs and can be loaded by other users
    public added? : string;
    public deleted : boolean = false;
    public ownedByEntityId?: number;
    public ownerEntityType?: string;
    public scopeRestrictions?: string;
    public defaultMetadataProtocol? :string;
    public abstractForIntegrationType? : number;
    public abstractForPremierPartnerId? : number;
    public wizardSessionId? : number;
}